import { computed, unref } from "vue";
import { useStore } from "vuex";

/**
 * Controls which Colleges should appear inside dropdown based on session
 * @param {allowedUniversities} Ref<Array> - The list of universities that the session allows.
 * @param {universitiesFromSearch} Ref<String> - The default/search result list of schools
 * @param {selectedSchool} Ref<String> - id/uuid of the selected school (Optional)
 */

export const useAllowedUniversities = (allowedUniversities, universitiesFromSearch, selectedSchool) => {
  const store = useStore();
  const profileCollege = computed(() => store.getters["getEntitiesFromProfile"]?.[0] ?? "");

  const universities = computed(() => {
    const schools = allowedUniversities.value.length <= 0 ? universitiesFromSearch.value : allowedUniversities.value;
    return schools.map((school) => ({
      label: school?.name,
      value: school?.ope_id,
      ...school,
    }));
  });

  const currentCollegeIsValid = computed(() => {
    if (allowedUniversities.value?.length <= 0) return true;
    return allowedUniversities.value?.includes(profileCollege.value);
  });

  const invalidCollegeFromProfile = computed(() => {
    return (
      profileCollege.value &&
      allowedUniversities.value?.length >= 1 &&
      !allowedUniversities?.value?.some((school) => school?.id === unref(selectedSchool))
    );
  });

  return { allowedUniversities, universities, currentCollegeIsValid, invalidCollegeFromProfile };
};
